import { Redirect } from '@reach/router';
import { graphql, withPrefix } from 'gatsby';
import React from 'react';
export default {
  Redirect,
  graphql,
  withPrefix,
  React
};